const { Node } = require('slate');
const isPlainObject = require('./isPlainObject');

const isAulaEditorState = (state) =>
  state != null && Node.isNodeList(state.value) && isPlainObject(state.context);

module.exports = isAulaEditorState;
